import React from 'react';
import styled from 'styled-components';
import { PortableText } from '@portabletext/react';
import sharedStyles from '@rsc/ui-components/styles';

const SupportArticleCalloutWrapper = styled.div`
  background: ${({ theme }) => theme.colors.callout};
  color: #262626;
  font-size: ${sharedStyles.fontSize['1xl']};
  font-weight: ${sharedStyles.fontWeight.bold};
  margin-bottom: 2rem;
  text-align: center;

  > p {
    padding: 0.5rem;
  }
`;

function SupportArticleCallout({ section }) {
  return (
    <SupportArticleCalloutWrapper>
      <PortableText value={section.calloutText.text} />
    </SupportArticleCalloutWrapper>
  );
}

export default SupportArticleCallout;
